export const BrandMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
    <defs>
      <linearGradient id="bm-g" x1="0" y1="0" x2="1" y2="1">
        <stop offset="0" stopColor="#BF953F" />
        <stop offset="0.45" stopColor="#F0E2B6" />
        <stop offset="0.75" stopColor="#C5A059" />
        <stop offset="1" stopColor="#AA771C" />
      </linearGradient>
    </defs>
    <path
      d="M6 48 C20 56 44 56 58 46"
      fill="none"
      stroke="url(#bm-g)"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M30 44 C28 28 38 13 54 11 C56 27 46 41 32 44 Z"
      fill="url(#bm-g)"
    />
    <path
      d="M33 42 C34 32 39 22 47 16"
      fill="none"
      stroke="#FBFAF6"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);
